import { PageId } from 'page-constants'
import { Cohort } from 'root-constants'
import { TPostPaymentFlowBaseConfig } from 'root-types'

import {
  PROGRESSBAR_STEPS,
  UPSELL_PROGRESSBAR_STEPS,
  UPSELL_PROGRESSBAR_STEPS_ACCOUNT_FIRST,
  WELLNESS_PROGRESSBAR_STEPS,
} from './progressSteps'

export type { TPostPaymentFlowBaseConfig }

const DEFAULT_POST_PAYMENT_PAGES: PageId[] = [
  PageId.SIGNUP,
  PageId.ACCOUNT,
  PageId.DOWNLOAD,
]

const UPSELL_PAGES: PageId[] = [
  PageId.UPSELL_GUIDE,
  PageId.UPSELL_GUIDE_V2,
  PageId.UPSELL_PODCAST,
  PageId.INAPP_PODCAST,
  PageId.UPSELL_AYAH_PA,
  PageId.INAPP_VOICEOVER,
  PageId.INAPP_VOICEOVER_V3,
  PageId.UPSELL_PARENTING,
]

const POST_PAYMENT_PAGES_WITH_UPSELL: PageId[] = [
  ...UPSELL_PAGES,
  ...DEFAULT_POST_PAYMENT_PAGES,
]

const DEFAULT_FINAL_PROGRESS_STEP = {
  id: PageId.DOWNLOAD,
  text: 'postPaymentProgress.accessPlan',
}

const WELLNESS_POST_PAYMENT_PAGES: PageId[] = [
  ...UPSELL_PAGES,
  PageId.INAPP_VOICEOVER_2,
  PageId.SIGNUP,
  PageId.ACCOUNT,
  PageId.APP_WELLNESS,
]

export const DEFAULT_POST_PAYMENT_FLOW_CONFIG: TPostPaymentFlowBaseConfig = {
  pages: DEFAULT_POST_PAYMENT_PAGES,
  progressSteps: PROGRESSBAR_STEPS,
  finalStep: DEFAULT_FINAL_PROGRESS_STEP,
  downloadPageId: PageId.DOWNLOAD,
}

export const UPSELL_POST_PAYMENT_FLOW_CONFIG: TPostPaymentFlowBaseConfig = {
  pages: POST_PAYMENT_PAGES_WITH_UPSELL,
  progressSteps: UPSELL_PROGRESSBAR_STEPS,
  finalStep: DEFAULT_FINAL_PROGRESS_STEP,
  downloadPageId: PageId.DOWNLOAD,
}

export const UPSELL_POST_PAYMENT_FLOW_CONFIG_ACCOUNT_FIRST: TPostPaymentFlowBaseConfig =
  {
    pages: POST_PAYMENT_PAGES_WITH_UPSELL,
    progressSteps: UPSELL_PROGRESSBAR_STEPS_ACCOUNT_FIRST,
    finalStep: DEFAULT_FINAL_PROGRESS_STEP,
    downloadPageId: PageId.DOWNLOAD,
  }

export const WELLNESS_POST_PAYMENT_FLOW_CONFIG: TPostPaymentFlowBaseConfig = {
  pages: WELLNESS_POST_PAYMENT_PAGES,
  progressSteps: WELLNESS_PROGRESSBAR_STEPS,
  finalStep: {
    id: PageId.APP_WELLNESS,
    text: 'postPaymentProgress.unlockApp',
  },
  downloadPageId: PageId.APP_WELLNESS,
}

export const POST_PAYMENT_PROGRESS_BAR_COHORTS: readonly Cohort[] = [
  Cohort.AP_WLDB_313,
  Cohort.AP_WLDB_QUIZ_313,
  Cohort.KP_BS_13_C,
  Cohort.KP_BS_13,
  Cohort.KP_BS_7_WTYPE,
  Cohort.KP_BS_7_WTYPE_C,
  Cohort.AP_QURAN_313_C,
  Cohort.AP_QURAN_313_C_AM,
  Cohort.AP_QURAN_313_CC,
  Cohort.AP_QURAN_313_CF,
  Cohort.AP_PA_440_C,
  Cohort.AP_PA_440,
  Cohort.FLOW_AYAH_314,
  Cohort.FLOW_AYAH_314_C,
  Cohort.AP_FINANCE_313_C,
  Cohort.AP_FINANCE_313_C_AM,
  Cohort.AP_FINANCE_313,
  Cohort.AP_FINANCE_313_AM,
  Cohort.AP_SD_313_C,
  Cohort.AP_SD_313_CC,
  Cohort.FLOW_AYAH_313,
  Cohort.AP_PARENTING_313_C,
  Cohort.AP_KNOWLEDGE_428_C,
]

export const ACCOUNT_BEFORE_UPSELL_COHORTS: readonly Cohort[] = [
  Cohort.AP_WLDB_313,
  Cohort.AP_WLDB_QUIZ_313,
  Cohort.AP_QURAN_313_C,
  Cohort.AP_QURAN_313_C_AM,
  Cohort.AP_QURAN_313_CF,
  Cohort.AP_PA_440_C,
  Cohort.FLOW_AYAH_313,
  Cohort.AP_FINANCE_313_C,
  Cohort.AP_FINANCE_313_C_AM,
  Cohort.AP_PA_440_AM,
  Cohort.AP_PA_440_C_AM,
  Cohort.AP_SD_313_C,
  Cohort.AP_SD_313_CC,
  Cohort.AP_PARENTING_313_C,
  Cohort.FLOW_AYAH_314,
  Cohort.FLOW_AYAH_314_C,
  Cohort.AP_KNOWLEDGE_428_C,
]
